/**
 * Testimonial cards stagger-reveal as the section scrolls into view,
 * matching the same treatment as the Collections product grid.
 */
import { revealOnScroll } from '@theme/premium-motion';

revealOnScroll('.flv-testimonial-card', { y: 26, scale: 0.97, duration: 0.7, stagger: 0.1 });
